import { render } from "./RankingSettings.vue?vue&type=template&id=e8ef0952&scoped=true"
import script from "./RankingSettings.vue?vue&type=script&lang=js"
export * from "./RankingSettings.vue?vue&type=script&lang=js"

import "./RankingSettings.vue?vue&type=style&index=0&id=e8ef0952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ef0952"]])

export default __exports__